export const DONT_HAVE_FILE_FILENAME = "explanation.txt";
export const WHY_REQUIRED_MODAL_NAME = "why_is_this_required_modal";
export const HOW_DO_I_GET_MODAL_NAME = "how_do_i_get_this_modal";
export const DONT_HAVE_MODAL_NAME = "dont_have_this_modal";
export const WAGE_DOC_ISSUE_MODAL_NAME = "wage_document_issue_modal";
export const SUCCESS_MODAL_NAME = "success_modal";
export const ALTERNATE_DOCS_MODAL_NAME = "alternate_documents_modal";
